let MobileIdentifier = {};

MobileIdentifier = () => {

  let userAgent = navigator.userAgent.toLowerCase(); 

  let android = userAgent.match(/android/i) !== null;

  let mobile = userAgent.match(/mobile/i) !== null;

  let ipad = userAgent.match(/iPad/i) !== null;

  let iphone = (userAgent.match(/iPhone/i) !== null);

  let iPod = (userAgent.match(/iPod/i) !== null);

  return (ipad || iphone || android || mobile || iPod);

};

module.exports = MobileIdentifier;


// WEBPACK FOOTER //
// ./src/js/services/MobileIdentifier.js